export default __webpack_public_path__ + "static/media/nub_connecticutBG.3c030507.jpg";